module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/162-germany-f6ab7c6131965691640b0671e9f400b1.svg";